import React from 'react';
import logo from '../assets/ims-logo.png';
import landingImage from '../assets/bg.png';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';
import { Box, Button, keyframes, Typography, Link } from '@mui/material';

const SignUp = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/');
  };

  return (
    <Box sx={{
    height: '100vh',
    display: 'flex',
    backgroundColor: '#fff',
    flexDirection: { xs: 'column', md: 'row' },
    overflowY: 'auto'
  }}>
      {/* Left Section - Image Only */}
      <Box sx={{
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',    
        backgroundColor: '#FFFAF0'
      }}>
        <Box
          component="img"
          src={landingImage}
          alt="Collaboration"
          sx={{
            height: '50%'
          }}
        />
      </Box>

      {/* Right Section */}
      <Box sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: 8,
        maxWidth: 500,
        margin: '0 auto'
      }}>
        <Box
          component="img"
          src={logo}
          alt="IMS Logo"
          sx={{ 
            width: 120,
            mb: 4,
          }}
        />
        
        <Typography variant="h3" sx={{ 
          mb: 2,
          fontWeight: 700,
          color: '#2D2D2D'
        }}>
          Exclusive access for members
        </Typography>
        
        <Typography variant="body1" sx={{ 
          mb: 4,
          color: '#6B6B6B',
          fontSize: '1.1rem'
        }}>
          This platform is available exclusively for cooperative members. 
          Please contact us to request access.
        </Typography>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <Typography variant="body2" paragraph>
            <Link href="mailto:info@signblast.com.au" color="primary">
              info@signblast.com.au
            </Link>
          </Typography>
        </Box>
        <Button
          fullWidth
          variant="contained"
          sx={{
            py: 1.5,
            borderRadius: 3,
            background: 'linear-gradient(45deg, #FF7A7A 30%,rgb(255, 210, 180) 90%)',
            '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: '0 4px 12px rgba(255, 122, 122, 0.3)'
            }
          }}
          onClick={handleBack}
        >
          Back
        </Button>

        <Footer sx={{ mt: 6 }} />
      </Box>
    </Box>
  );
};

export default SignUp;